import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'

type ViewFrameImage = {
    idx: number;
    image: HTMLImageElement;
    loaded: boolean;
    error: boolean;
}

@Component({

})
export default class ViewFrame  extends Vue {
    @Prop({ type: String }) bodyUrl!: string;
    @Prop({ type: String, default: null }) content!: string | null;
    @Prop({ type: Number, default: 0 }) endMargin!: number;

    contentLoaded: boolean = false;
    frameImages: ViewFrameImage[] = []; 
    mBodyUrl: string = '';   

    @Watch('content')
    onContentChanged(newVal: string | null) {
        if(newVal != null && newVal.length > 0) {
            this.mountContent(newVal);
        } else {
            this.mBodyUrl = this.bodyUrl;
        }        
    }

    @Watch('bodyUrl')
    onUrlChanged(newVal: string) {
        this.mBodyUrl = newVal;
    }

    mounted() {
        if(this.content != null && this.content.length > 0) {
            this.mountContent(this.content);
        } else {
            this.mBodyUrl = this.bodyUrl;
        }
    }

    mountContent(content: string) {
        var ifrmContent = this.$refs.refIfrmContent as HTMLIFrameElement;
        var contentWindow = ifrmContent.contentWindow;

        if(contentWindow) {
            contentWindow.document.body.innerHTML = content;
            
            var linkElem = contentWindow.document.createElement("link");
            linkElem.setAttribute("rel", "stylesheet");
            linkElem.setAttribute("type", "text/css");
            linkElem.setAttribute("href", '/cm/gres/libs/synap-editor/SynapEditor/iframeMode/contentsEditStyle.css');
            contentWindow.document.getElementsByTagName("head")[0].appendChild(linkElem); 
        }
    }

    mountFrameImages(contentFrame: HTMLIFrameElement) {
        if(contentFrame.contentWindow) {
            var contentWindow = contentFrame.contentWindow;
            var ifrmImages = contentWindow.document.images;
            this.adjustScrollHeight(contentFrame);

            if(ifrmImages.length > 0) {
                this.frameImages = [...ifrmImages].map((img, idx) => <ViewFrameImage>{
                    idx: idx,
                    error: false,
                    image: img,
                    loaded: false
                });

                this.frameImages.forEach(frmImg => {
                    if(frmImg.image.complete) {
                        frmImg.loaded = true;
                    } else {
                        frmImg.image.addEventListener( 'load', () => {
                            console.log('viewframe-image-loaded', frmImg.image.src);
                            frmImg.loaded = true; 
                            this.adjustScrollHeight(contentFrame);
                            this.emitContentFrameLoaded();
                        }, false)
    
                        frmImg.image.addEventListener('error', () => {
                            console.log('viewframe-image-error', frmImg.image.src);
                            frmImg.error = true;
                            this.emitContentFrameLoaded();
                        }, false)
                    }
                });
            } 

            this.emitContentFrameLoaded();
        }
    }

    emitContentFrameLoaded() {
        if(this.contentLoaded)
            return 

        var ifrmContent = this.$refs.refIfrmContent as HTMLIFrameElement;
        console.log('checkEmitLoaded', this.frameImages);
        if(this.frameImages.length > 0) {
            if(this.frameImages.every(i => i.loaded || i.error || i.image.complete)) {
                this.$emit('contentLoaded', ifrmContent);
                this.contentLoaded = true;
            }
        } else {
            this.$emit('contentLoaded', ifrmContent);
            this.contentLoaded = true;
        }
    }

    onContentFrameLoaded(e: Event | null) {
        this.contentLoaded = false;

        this.$nextTick(() => {
            var ifrmContent = this.$refs.refIfrmContent as HTMLIFrameElement;
            this.mountFrameImages(ifrmContent);         
        })        
    }

    adjustScrollHeight(ifrmContent: HTMLIFrameElement) {
        if(ifrmContent.contentWindow) {
            ifrmContent.style.width = (ifrmContent.contentWindow.document.body.scrollWidth) + 'px';
            ifrmContent.style.height = (ifrmContent.contentWindow.document.body.scrollHeight + this.endMargin) + 'px';
        }        
    }
}